import axios from "axios";
import { baseURL } from "../Constants";
import { LookingForPlayers } from "../models/LookingForPlayers";

const url = `${baseURL}/LookingForPlayers`;

export const fetchLookingForPlayersPosts = async (): Promise<LookingForPlayers[]> => {
    try {
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const createLookingForPlayersPost = async (post: LookingForPlayers): Promise<LookingForPlayers> => {
    try {
        const response = await axios.post(`${url}`, post);
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const updateLookingForPlayersPost = async (post: LookingForPlayers): Promise<LookingForPlayers> => {
    try {
        const response = await axios.post(`${url}/update`, post);
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const deleteLookingForPlayersPost = async (id: number): Promise<boolean> => {
    try {
        const response = await axios.post(`${url}/delete/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
}
